import { render, staticRenderFns } from "./index_mobile.vue?vue&type=template&id=b87c3d6e&"
import script from "./index_mobile.vue?vue&type=script&lang=js&"
export * from "./index_mobile.vue?vue&type=script&lang=js&"
import style0 from "./index_mobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports